import React, { useState, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import TextField from "@material-ui/core/TextField/index";
import { v4 as uuid } from "uuid";
import axios from "axios";
import { Formik } from "formik";
import * as Yup from "yup";
import InputMask from "react-input-mask";
// import ReactSelect from "../../UI/ReactSelect";


export default function Edit(props) {
  const {
    onHide,
    show,
    employeeList,
    onEmployeeLists,
    skip,
    take,
    sortField,
    orderBy,
    // grades
  } = props;
  const { id, email, phone, firstName, lastName } = employeeList;
  const [isError, setIsError] = useState("");

  // const [gradesOptions, setGradesOptions] = useState([]);

  // const [gradesOption, setGradesOption] = React.useState(null);


  // useEffect(() => {
  //   setGradesOptions(
  //     grades.map((suggestion) => ({
  //       value: suggestion.id,
  //       label: suggestion.gradeNumber,
  //     }))
  //   );
  // }, [grades]);

  // function handleChangeGrade(value, setFieldValue) {
  //   setGradesOption((prevState) => value);
  //   setFieldValue("gradeId", value.value);
  // }

  // useEffect(() => {
  //   setGradesOption((prev) =>
  //     gradesOptions.find((option) => option.value === gradeId)
  //   );
  // }, [gradeId, gradesOptions]);



  const onPutEmployeeList = (values, resetForm, setSubmitting) => {
    const employeeList = {
      id: id,
      email: values.email,
      // phone: values.phone,
      phone: values.phone,
      firstName: values.firstName,
      lastName: values.lastName,
      // gradeId: values.gradeId,
      // profession: values.profession,


    };
    axios
      .put(`${process.env.REACT_APP_API_URL}employee`, employeeList, {
        headers: {
          "x-requestid": uuid(),
        },
      })
      .then((res) => {
        onHide(false);
        resetForm();
        setSubmitting(false);
        onEmployeeLists(skip, take, sortField, orderBy);
      })
      .catch(
        ({
          response: {
            data: { message },
          },
        }) => {
          setIsError(message);
        }
      );
  };

  const EditSchema = Yup.object().shape({
    // email: Yup.string(),
    email: Yup.string()
      .email("Wrong email format. E.g. jhon.doe@example.com"),
    phone: Yup.string(),
  });

  const getInputClasses = (touched, errors, fieldName) => {
    if (touched[fieldName] && errors[fieldName]) {
      return true;
    }
    if (touched[fieldName] && errors[fieldName]) {
      return false;
    }

    return false;
  };

  return (
    <Modal
      onHide={onHide}
      show={show}
      size="sm"
      aria-labelledby="edit"
      className="modal-right pr-0"
    >
      {employeeList &&
        Object.keys(employeeList).length !== 0 &&
        employeeList.constructor === Object && (
          <Formik
            initialValues={{
              email: email ? email : "",
              phone: phone,
              firstName: firstName,
              lastName: lastName,
              // gradeId: gradeId,
              // profession: profession,

            }}
            validationSchema={EditSchema}
            onSubmit={(values, { resetForm, setSubmitting }) => {
              onPutEmployeeList(values, resetForm, setSubmitting);
            }}
          >
            {({
              values,
              errors,
              touched,
              handleSubmit,
              handleChange,
              handleBlur,
              resetForm,
              setFieldValue,
            }) => (
              <form onSubmit={handleSubmit}>
                <Modal.Header closeButton>
                  <Modal.Title id="edit">Edit</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <div className="col-12 pl-4 pr-4">
                    <div className="row">

                      <div className="col-12 col-md-12 col-lg-12">
                        <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                          <TextField
                            id="firstName"
                            label="Firstname"
                            placeholder="Firstname"
                            className="w-100"
                            value={values.firstName}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            error={getInputClasses(touched, errors, "firstName")}
                          />
                        </div>
                        {touched.firstName && errors.firstName ? (
                          <div className="fv-plugins-message-container">
                            <div className="fv-help-block">{errors.firstName}</div>
                          </div>
                        ) : null}
                      </div>


                      <div className="col-12 col-md-12 col-lg-12">
                        <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                          <TextField
                            id="lastName"
                            label="Lastname"
                            placeholder="Lastname"
                            className="w-100"
                            value={values.lastName}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            error={getInputClasses(touched, errors, "lastName")}
                          />
                        </div>
                        {touched.lastName && errors.lastName ? (
                          <div className="fv-plugins-message-container">
                            <div className="fv-help-block">{errors.lastName}</div>
                          </div>
                        ) : null}
                      </div>

                      <div className="col-12 col-md-12 col-lg-12">
                        <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                          <TextField
                            id="email"
                            label="Email"
                            placeholder="Email"
                            className="w-100"
                            value={values.email}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            error={getInputClasses(touched, errors, "email")}
                          />
                        </div>
                        {touched.email && errors.email ? (
                          <div className="fv-plugins-message-container">
                            <div className="fv-help-block">{errors.email}</div>
                          </div>
                        ) : null}
                      </div>
                      <div className="col-12 col-md-12 col-lg-12">
                        <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                          {/* <TextField
                            id="phone"
                            label="Phone"
                            placeholder="Phone"
                            className="w-100"
                            value={values.phone}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            error={getInputClasses(touched, errors, "phone")}
                          /> */}
                          <InputMask
                            mask="\9\94999999999"
                            value={values.phone}
                            // onChange={(e) => handleChangePhoneNumber(e)}
                            onChange={handleChange}
                            disabled={false}
                            maskChar=""
                            id="phone"
                            type="number"

                          >
                            {() =>
                              <TextField
                                label="Phone number"
                                placeholder="Phone number"
                                className="w-100"
                                name="phone"
                              // onKeyDown={handleEnter}

                              // error={getInputClasses("phone")}
                              // {...formik.getFieldProps("phone")}
                              />}
                          </InputMask>
                        </div>
                        {touched.phone && errors.phone ? (
                          <div className="fv-plugins-message-container">
                            <div className="fv-help-block">{errors.phone}</div>
                          </div>
                        ) : null}

                      </div>

{/* 
                      <div className="col-12 col-md-12 col-lg-12">
                        <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                          <ReactSelect
                            suggestions={gradesOptions}
                            handleChangeSingle={(value) =>
                              handleChangeGrade(value, setFieldValue)
                            }
                            single={gradesOption}
                            label="Grade Id"
                            placeholder="Grade Id"
                            error={getInputClasses(touched, errors, "gradeId")}
                            inputId="gradeId"
                          />
                        </div>

                        {touched.gradeId && errors.gradeId ? (
                          <div className="fv-plugins-message-container">
                            <div className="fv-help-block">
                              {errors.gradeId}
                            </div>
                          </div>
                        ) : null}
                      </div> */}


                      <div className="col-12 col-md-12 col-lg-12">
                        {/* <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                          <TextField
                            id="profession"
                            label="Profession"
                            placeholder="Profession"
                            className="w-100"
                            value={values.profession}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            error={getInputClasses(touched, errors, "profession")}
                          />
                        </div> */}
                        {/* {touched.profession && errors.profession ? (
                          <div className="fv-plugins-message-container">
                            <div className="fv-help-block">{errors.profession}</div>
                          </div>
                        ) : null} */}

                        {isError && (
                          <div className="fv-plugins-message-container">
                            <div className="fv-help-block MuiFormLabel-root Mui-error">
                              {isError}
                            </div>
                          </div>
                        )}
                      </div>

                    </div>
                  </div>
                </Modal.Body>
                <Modal.Footer>
                  <Button
                    variant="light"
                    onClick={() => {
                      onHide(false);
                      resetForm();
                    }}
                  >
                    Close
                  </Button>
                  <Button type="submit">Edit</Button>
                </Modal.Footer>
              </form>
            )}
          </Formik>
        )}
    </Modal>
  );
}
